<template lang='pug'>
  .preview.clearfix
      el-menu(
        mode="horizontal"
        @select="select_tab"
        default-active='0')
        el-menu-item(
          v-for='(tab, index) in tabs'
          :key='index'
          :index='index.toString()')
          | {{ tab }}
      div.share_select(v-if='has_shares_widget')
        h4
          | Choose a share option for your preview
        el-button(
          @click='previous_share')
          | <
        el-select(
          v-model='share_id'
          placeholder='Select your share'
          @change='change_selected_share($event)')
          el-option(
            v-for='share in shares'
            :key='share.id'
            :label='share.name'
            :value='share.id')
        el-button(
          @click='next_share')
          | >
      div(:class="[`hardware`, `${current_tab}`]")
        .view(v-loading='loading')
          iframe(
            class="frame"
            :src='landing_page_url'
            @load="iframe_loaded")
</template>

<script>
  import { db, config_obj } from '../utils/firebase.js'
  export default {
    name: 'preview',
    props: {
      shares: {
        type: Array,
        required: false
      },
      selected_share_id: {
        type: String,
        required: false,
        default: ''
      }
    },
    data() {
      return {
        current_tab: 'mobile',
        tabs: ['Mobile', 'Tablet', 'Desktop'],
        project: config_obj.firebase.projectId,
        lp_base_path: config_obj.lp_base_path,
        loading: true,
        share_id: this.selected_share_id,
        landing_page_widgets: []
      }
    },
    firestore() {
      return {
        landing_page_widgets: db.collection(`landing_pages/${this.campaign_id}/landing_page_widgets`)
      }
    },
    computed: {
      campaign_id() {
        return this.$route.params.campaign_id
      },
      has_shares_widget() {
        return _.find(this.landing_page_widgets, widget => widget.widget.name === 'shares')
      },
      landing_page_url() {
        return  `${this.lp_base_path}/landing_pages/${this.$route.params.campaign_id}/retailers/default${this.share_id !== '' ? `?share_setting_id=${this.share_id}` : ''}`
      },
    },
    watch: {
      selected_share_id() {
        this.share_id = this.selected_share_id
      }
    },
    methods: {
      change_selected_share(share_id) {
        this.loading = true
        this.$emit('change_selected_share', share_id)
      },
      previous_share() {
        this.loading = true
        if (this.selected_share_id === this.shares[0].id) {
          this.$emit('change_selected_share', this.shares[this.shares.length - 1].id)
        } else {
          let new_share_id = parseInt(this.share_id)
          new_share_id = (new_share_id - 1).toString()
          this.$emit('change_selected_share', new_share_id)
        }
        this.$forceUpdate()
      },
      next_share() {
        this.loading = true
        if (this.selected_share_id === this.shares[this.shares.length - 1].id) {
          this.$emit('change_selected_share', this.shares[0].id)
        } else {
          let new_share_id = parseInt(this.share_id)
          new_share_id = (new_share_id + 1).toString()
          this.$emit('change_selected_share', new_share_id)
        }
        this.$forceUpdate()
      },
      select_tab(index) {
        this.current_tab = this.tabs[index].toLowerCase()
      },
      iframe_loaded() {
        this.loading = false
      }
    }
  }
</script>

<style lang='scss'>
  @import 'compass-mixins';
  @import "@promoboxx/pbxx2component/src/styles/variables_and_mixins";
  .preview {
    font-family: "gotham-round";
    position: absolute;
    right: 0;
    top: 50px;
    bottom:0;
    left: 0;
    overflow: auto;
    background-color: get-color(white);
    z-index: 2;
    .el-menu {
        text-align: center;
      }
      .el-menu--horizontal > .el-menu-item {
        float: none;
        display: inline-block;
        zoom: 1;
      }
    .hardware {
      padding-top: 40px;
      box-shadow: 0px 0px 0px 3px #1f1f1f, 0px 0px 0px 4px #191919, 0px 0px 0px 5px #111;
      @include border-radius(40px);
      background-color: get-color(gray-lightest);
      .preview {
        margin: 0 auto;
        overflow: auto;
        background-color: get-color(white);
        @include border-radius(5px);
      }
      &.mobile,
      &.tablet {
        border: 2px solid black;
      }
      &.mobile {
        margin: 50px auto;
        position: relative;
        width: 405px;
        height: 710px;
        .preview {
          width: 375px;
          height: 622px;
        }
      }
      &.tablet {
        margin: 50px auto;
        position: relative;
        width: 862px;
        height: 980px;
        .preview {
          width: 700px;
          height: 900px;
        }
      }
      &.desktop {
        margin: 10px auto 0;
        padding-top:0;
        height: calc(100vh - 40px);
        box-shadow: none;
        @include border-radius(0);
        background-color: get-color(white);
        .preview {
          @include border-radius(0);
        }
      }
      .view {
        text-align: center;
        background: white;
        width: 90%;
        height: 100%;
        margin: 0 auto;
        height: 90%;
        p {
          font-size: 32px;
        }
      }
      .frame {
        height: 100%;
        width: 100%;
      }
    }
  }

  .share_select {
    margin-top: 20px;
    text-align: center;
    .el-select {
      width: 33%;
      margin: 10px 10px 0;
    }
    .el-button {
      // Match height of .el-select next to it
      padding-top: 11px;
      padding-bottom: 12px;
    }
  }
</style>
